export default {
    state: {
        currentView: "list",
        config: [],
    },

    getters: {
        currentView: (state) => {
            return state.currentView;
        },
        apiConfig: (state) => {
            return state.config.api;
        },
        listConfig: (state) => {
            return state.config.list;
        },
        mapConfig: (state) => {
            return state.config.map;
        },
        localization: (state) => {
            return state.config.localization;
        },
    },

    mutations: {
        SET_CURRENT_VIEW(state, n) {
            state.currentView = n;
        },
        BUILD_APP_CONFIG(state, n) {
            state.config = n;
        },
    },

    actions: {
        setCurrentView({ commit }, payload) {
            commit("SET_CURRENT_VIEW", payload);
        },
        buildAppConfig({ commit }, payload) {
            commit("BUILD_APP_CONFIG", payload);
        },
    },
};
